// src/app/modules/adminrh/recrutement/Cvtheque/CVTheque.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Plus,
    X,
    Trash2,
    Eye,
    Edit2,
    Search,
    Upload,
    Sparkles,
    Download,
    FileText,
    User,
} from "lucide-react";
import Swal from "sweetalert2";
import "./Cvtheque.css";

import {
    FETCH_CANDIDATS_REQUEST,
    fetchCandidatsRequest,
    createCandidatRequest,
    updateCandidatRequest,
    deleteCandidatRequest,
} from "../../../../../redux/actions/candidatsActions";

import { fetchEtablissementsRequest } from "../../../../../redux/actions/etablissementsActions";
import { API_BASE_URL } from "../../../../../../api";

const Modal = ({ open, title, children, footer, onClose, size = "md" }) => {
    if (!open) return null;
    const sizeClass = size === "lg" ? "cvtModal__panel--lg" : "";
    return (
        <div className="cvtModal" role="dialog" aria-modal="true" onMouseDown={onClose}>
            <div className={`cvtModal__panel ${sizeClass}`} onMouseDown={(e) => e.stopPropagation()}>
                <div className="cvtModal__header">
                    <div className="cvtModal__title">{title}</div>
                    <button className="cvtIconBtn" onClick={onClose} aria-label="Fermer" type="button">
                        <X size={18} />
                    </button>
                </div>
                <div className="cvtModal__body">{children}</div>
                {footer && <div className="cvtModal__footer">{footer}</div>}
            </div>
        </div>
    );
};

// Helper: show Swal above modals
const showSwal = (options) => {
    Swal.fire({
        ...options,
        customClass: {
            ...(options.customClass || {}),
            container: "swal-above-modal",
        },
        didOpen: () => {
            const container = document.querySelector(".swal-above-modal");
            if (container) container.style.zIndex = "99999";
            if (options.didOpen) options.didOpen();
        },
    });
};

const GENRE_OPTIONS = [
    { value: "HOMME", label: "Homme" },
    { value: "FEMME", label: "Femme" },
];

const PIECE_IDENTITE_OPTIONS = [
    { value: "CIN", label: "CIN" },
    { value: "PASSEPORT", label: "Passeport" },
    { value: "CARTE_SEJOUR", label: "Carte séjour" },
];

const NIVEAU_ETUDES_OPTIONS = [
    { value: "DIPLOME_BAC_2", label: "Diplôme (Bac + 2)" },
    { value: "LICENCE_BAC_3", label: "Licence (Bac + 3)" },
    { value: "MASTER_BAC_5", label: "Master (Bac + 5)" },
    { value: "INGENIEUR_BAC_5", label: "Ingénieur (Bac + 5)" },
    { value: "DOCTORAT_ET_PLUS", label: "Doctorat et plus" },
];

const ANNEES_EXPERIENCE_OPTIONS = [
    "< 1 an",
    "> 1 an",
    "> 2 ans",
    "> 5 ans",
    "> 10 ans",
];

const OPTION_SPECIALITE_OPTIONS = [
    { value: "DEVELOPPEMENT_WEB", label: "Développement Web" },
    { value: "DEVELOPPEMENT_MOBILE", label: "Développement Mobile" },
    { value: "GENIE_LOGICIEL", label: "Génie Logiciel" },
    { value: "DATA_SCIENCE", label: "Data Science" },
    { value: "IA_ML", label: "IA / ML" },
    { value: "CYBERSECURITE", label: "Cybersécurité" },
    { value: "RESEAUX_SYSTEMES", label: "Réseaux & Systèmes" },
    { value: "CLOUD_DEVOPS", label: "Cloud / DevOps" },
    { value: "QA_TEST", label: "QA / Test" },
    { value: "BI_DECISIONNEL", label: "BI / Décisionnel" },
    { value: "FINANCE_COMPTABILITE", label: "Finance / Comptabilité" },
    { value: "MARKETING_COMMUNICATION", label: "Marketing / Communication" },
    { value: "RESSOURCES_HUMAINES", label: "Ressources Humaines" },
    { value: "MANAGEMENT_GESTION_PROJET", label: "Management / Gestion de projet" },
    { value: "LOGISTIQUE_SUPPLY_CHAIN", label: "Logistique / Supply Chain" },
    { value: "JURIDIQUE", label: "Juridique" },
    { value: "GENIE_CIVIL", label: "Génie Civil" },
    { value: "GENIE_INDUSTRIEL", label: "Génie Industriel" },
    { value: "ELECTRONIQUE_EMBARQUE", label: "Électronique embarquée" },
    { value: "MECANIQUE", label: "Mécanique" },
    { value: "VENTE_BUSINESS_DEV", label: "Vente / Business Dev" },
    { value: "SUPPORT_IT", label: "Support IT" },
    { value: "AUTRE", label: "Autre" },
];

const TYPE_CANDIDATURE_OPTIONS = [
    { value: "REPONSE_OFFRE", label: "Réponse à une offre" },
    { value: "CANDIDATURE_SPONTANEE", label: "Candidature spontanée" },
    { value: "AUTRE", label: "Autre" },
];

const SOURCE_OPTIONS = [
    { value: "SITES_CARRIERE", label: "Sites carrière" },
    { value: "CHASSEURS_TETE", label: "Chasseurs de tête" },
    { value: "PARTENAIRES_ACADEMIQUES", label: "Partenaires académiques" },
    { value: "COOPTATION_RECOMMENDATION", label: "Cooptation / recommendation" },
    { value: "AUTRE", label: "Autre" },
];

const labelFromOptions = (opts, value, fallback = "—") => {
    if (!value) return fallback;
    const o = opts.find((x) => String(x.value) === String(value));
    return o?.label || String(value);
};

const normalizeApiBase = () => {
    const base = String(API_BASE_URL || "").replace(/\/$/, "");
    if (/\/api$/i.test(base)) return base;
    return `${base}/api`;
};

const buildCvUrl = (filename) => {
    if (!filename) return "#";
    return `${normalizeApiBase()}/candidat-theque/cv/${encodeURIComponent(filename)}`;
};

const buildPieceUrl = (filename) => {
    if (!filename) return "#";
    return `${normalizeApiBase()}/candidat-theque/pieces/${encodeURIComponent(filename)}`;
};

const STATIC_PARSED_CV = {
    title: "CV 1: FARIS AMINA",
    nom: "FARIS",
    prenom: "AMINA",
    email: "aminafaris10@gmail.com",
    telephone: "06.00.69.20.22",
    sexe: "Femme",
    niveauEtude: "Master (Bac + 5)",
    specialite: "Développement FullStack",
    anneesExperience: "2",
    diplome: "Master professionnel en Big Data et Cloud Computing",
    etablissement: "ENSET",
    cvAssocie: "Recruiter System Connect.docx",
};

const normalizeCandidat = (c) => {
    const id = c?.id;
    const nom = c?.nomCandidat ?? c?.nom ?? "";
    const prenom = c?.prenomCandidat ?? c?.prenom ?? "";
    const email = c?.emailCandidat ?? c?.email ?? "";
    const phone = c?.phoneCandidat ?? c?.phone ?? c?.telephone ?? "";
    const adresse = c?.adresseCandidat ?? c?.adresse ?? "";
    const genre = c?.genre ?? c?.sexe ?? "";
    const pieceIdentite = c?.pieceIdentite ?? c?.pieceIdentiteType ?? c?.pieceIdentiteTypeEnum ?? "";
    const numPieceIdentite = c?.numPieceIdentite ?? c?.numeroPieceIdentite ?? "";
    const niveauEtude =
        c?.niveauxEtudes ??
        c?.niveauEtude ??
        c?.niveauEtudes ??
        "";
    const optionSpecialite = c?.specialiteOption ?? c?.optionSpecialite ?? "";
    const typeCandidature = c?.typeCandidature ?? c?.type ?? "";
    const anneExperience = c?.anneExperience ?? c?.anneesExperience ?? c?.experience ?? "";
    const diplomeObtenu = c?.diplome ?? c?.diplomeObtenu ?? "";
    const etablissementId =
        c?.etablissementId ?? c?.etablissement_id ?? c?.etablissement?.id ?? null;
    const autreEtablissement = c?.autreEtablissement ?? c?.autreEcole ?? "";
    const source = c?.source ?? "";
    const cv = c?.cvDocument ?? c?.cv ?? c?.cvFileName ?? c?.cvUrl ?? "";
    const pieceIdentiteDocument = c?.pieceDocument ?? c?.pieceIdentiteDocument ?? c?.pieceUrl ?? "";

    return {
        raw: c,
        id,
        nom,
        prenom,
        email,
        phone,
        adresse,
        genre,
        pieceIdentite,
        numPieceIdentite,
        niveauEtude,
        anneExperience,
        diplomeObtenu,
        etablissementId,
        autreEtablissement,
        optionSpecialite,
        typeCandidature,
        source,
        cv,
        pieceIdentiteDocument,
    };
};

export default function CVTheque() {
    const dispatch = useDispatch();

    const candState = useSelector((s) => s.candidats || {});
    const candidatsRaw = candState.candidats || candState.items || candState.data || [];
    const candLoading = !!candState.loading;

    const etabState = useSelector((s) => s.etablissements || {});
    const etablissements = etabState.etablissements || [];
    const etabLoading = !!etabState.loading;

    const candidats = useMemo(
        () => (Array.isArray(candidatsRaw) ? candidatsRaw.map(normalizeCandidat) : []),
        [candidatsRaw]
    );

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showParserModal, setShowParserModal] = useState(false);
    const [parserStatus, setParserStatus] = useState("idle");
    const [parserFileName, setParserFileName] = useState("");

    const [selectedCandidat, setSelectedCandidat] = useState(null);

    const emptyForm = {
        nom: "",
        prenom: "",
        email: "",
        phone: "",
        adresse: "",
        genre: "",
        pieceIdentite: "",
        numPieceIdentite: "",
        niveauEtude: "",
        anneExperience: "",
        diplomeObtenu: "",
        etablissementId: "",
        autreEtablissement: "",
        optionSpecialite: "",
        typeCandidature: "",
        source: "",
        cvFile: null,
        pieceFile: null,
        cvPreview: null,
        piecePreview: null,
    };

    const [form, setForm] = useState(emptyForm);
    const resetForm = () => setForm(emptyForm);

    const [filters, setFilters] = useState({
        fullname: "",
        optionSpecialite: "",
        typeCandidature: "",
        diplomeObtenu: "",
        niveauEtude: "",
        ecole: "",
    });

    const isAnyFilterFilled = Object.values(filters).some((v) => String(v || "").trim() !== "");

    useEffect(() => {
        dispatch(fetchCandidatsRequest());
        dispatch(fetchEtablissementsRequest());
    }, [dispatch]);

    useEffect(() => {
        const isAnyModalOpen =
            showAddModal || showEditModal || showViewModal || showDeleteModal || showParserModal;
        document.body.style.overflow = isAnyModalOpen ? "hidden" : "unset";
        return () => { document.body.style.overflow = "unset"; };
    }, [showAddModal, showEditModal, showViewModal, showDeleteModal, showParserModal]);

    useEffect(() => {
        if (candState?.success && showAddModal) {
            setShowAddModal(false);
            resetForm();
        }
    }, [candState?.success, showAddModal]);

    useEffect(() => {
        if (parserStatus !== "analyzing") return undefined;
        const timer = window.setTimeout(() => {
            setParserStatus("done");
        }, 1400);
        return () => window.clearTimeout(timer);
    }, [parserStatus]);

    const etabOptions = useMemo(() => {
        const list = Array.isArray(etablissements) ? etablissements : [];
        return list
            .map((e) => ({
                id: e.id,
                label: e.abbreviation || e.code || e.nom || e.name || `Etablissement #${e.id}`,
                raw: e,
            }))
            .sort((a, b) => (a.label || "").localeCompare(b.label || ""));
    }, [etablissements]);

    const selectedEtabObj = useMemo(() => {
        if (!form.etablissementId) return null;
        return etabOptions.find((x) => String(x.id) === String(form.etablissementId)) || null;
    }, [form.etablissementId, etabOptions]);

    const isAutreEtab = useMemo(() => {
        const label = (selectedEtabObj?.label || "").toUpperCase();
        const code = String(selectedEtabObj?.raw?.code || "").toUpperCase();
        const abbr = String(selectedEtabObj?.raw?.abbreviation || "").toUpperCase();
        return label.includes("AUTRE") || code === "AUTRE" || abbr === "AUTRE";
    }, [selectedEtabObj]);

    const filteredCandidats = useMemo(() => {
        let list = [...candidats];
        const qFull = filters.fullname.trim().toLowerCase();
        const qDiplome = filters.diplomeObtenu.trim().toLowerCase();
        const niveau = filters.niveauEtude;
        const ecole = filters.ecole;
        const specialite = filters.optionSpecialite;
        const typeCand = filters.typeCandidature;

        if (qFull) list = list.filter((c) => `${c.nom} ${c.prenom}`.toLowerCase().includes(qFull));
        if (qDiplome) list = list.filter((c) => String(c.diplomeObtenu || "").toLowerCase().includes(qDiplome));
        if (niveau) list = list.filter((c) => String(c.niveauEtude || "") === String(niveau));
        if (ecole) list = list.filter((c) => String(c.etablissementId || "") === String(ecole));
        if (specialite) list = list.filter((c) => String(c.optionSpecialite || "") === String(specialite));
        if (typeCand) list = list.filter((c) => String(c.typeCandidature || "") === String(typeCand));

        return list;
    }, [candidats, filters]);

    const handleFilterChange = (field, value) => setFilters((p) => ({ ...p, [field]: value }));
    const resetFilters = () => setFilters({
        fullname: "",
        optionSpecialite: "",
        typeCandidature: "",
        diplomeObtenu: "",
        niveauEtude: "",
        ecole: "",
    });

    const openCreate = () => { resetForm(); setSelectedCandidat(null); setShowAddModal(true); };
    const closeCreate = () => { setShowAddModal(false); resetForm(); };

    const resetParser = () => {
        setParserStatus("idle");
        setParserFileName("");
    };

    const openParser = () => {
        resetParser();
        setShowParserModal(true);
    };

    const closeParser = () => {
        setShowParserModal(false);
        resetParser();
    };

    const openEdit = (c) => {
        setSelectedCandidat(c);
        setForm({
            nom: c.nom || "",
            prenom: c.prenom || "",
            email: c.email || "",
            phone: c.phone || "",
            adresse: c.adresse || "",
            genre: c.genre || "",
            pieceIdentite: c.pieceIdentite || "",
            numPieceIdentite: c.numPieceIdentite || "",
            niveauEtude: c.niveauEtude || "",
            anneExperience: c.anneExperience || "",
            diplomeObtenu: c.diplomeObtenu || "",
            etablissementId: c.etablissementId ? String(c.etablissementId) : "",
            autreEtablissement: c.autreEtablissement || "",
            optionSpecialite: c.optionSpecialite || "",
            typeCandidature: c.typeCandidature || "",
            source: c.source || "",
            cvFile: null,
            pieceFile: null,
            cvPreview: null,
            piecePreview: null,
        });
        setShowEditModal(true);
    };

    const closeEdit = () => { setShowEditModal(false); setSelectedCandidat(null); resetForm(); };
    const openView = (c) => { setSelectedCandidat(c); setShowViewModal(true); };
    const closeView = () => { setShowViewModal(false); setSelectedCandidat(null); };
    const openDelete = (c) => { setSelectedCandidat(c); setShowDeleteModal(true); };
    const closeDelete = () => { setShowDeleteModal(false); setSelectedCandidat(null); };

    const handleFileChange = (field, e) => {
        const file = e.target.files?.[0] || null;
        if (!file) return;
        if (field === "cv") setForm((p) => ({ ...p, cvFile: file, cvPreview: file.name }));
        else if (field === "piece") setForm((p) => ({ ...p, pieceFile: file, piecePreview: file.name }));
    };

    const handleParserFileChange = (e) => {
        const file = e.target.files?.[0] || null;
        if (!file) return;
        setParserFileName(file.name);
        setParserStatus("analyzing");
    };

    const buildCandidatFormData = (p, ignoreDuplicateWarning = false) => {
        const fd = new FormData();

        const payload = {
            nom: p.nom?.trim(),
            prenom: p.prenom?.trim(),
            email: p.email?.trim() || null,
            phone: p.phone?.trim() || null,
            adresse: p.adresse?.trim() || null,
            genre: p.genre || null,
            pieceIdentite: p.pieceIdentite || null,
            numPieceIdentite: p.numPieceIdentite?.trim() || null,
            anneExperience: p.anneExperience || null,
            niveauxEtudes: p.niveauEtude || null,
            diplome: p.diplomeObtenu?.trim() || null,
            optionSpecialite: p.optionSpecialite || null,
            typeCandidature: p.typeCandidature || null,
            source: p.source || null,
            etablissementId: p.etablissementId ? Number(p.etablissementId) : null,
            autreEtablissement: isAutreEtab ? (p.autreEtablissement?.trim() || null) : null,
            ignoreDuplicateWarning,
        };

        fd.append("payload", JSON.stringify(payload));
        if (p.cvFile) fd.append("cv", p.cvFile);
        if (p.pieceFile) fd.append("pieceDocument", p.pieceFile);

        return fd;
    };

    const submitCreate = () => {
        if (!form.nom.trim() || !form.prenom.trim()) {
            showSwal({ icon: "warning", text: "Nom et prénom obligatoires", timer: 2000, showConfirmButton: false });
            return;
        }
        if (!form.email.trim()) {
            showSwal({ icon: "warning", text: "Email obligatoire", timer: 2000, showConfirmButton: false });
            return;
        }
        if (!form.phone.trim()) {
            showSwal({ icon: "warning", text: "Téléphone obligatoire", timer: 2000, showConfirmButton: false });
            return;
        }
        if (!form.cvFile) {
            showSwal({ icon: "warning", text: "Le CV est obligatoire", timer: 2000, showConfirmButton: false });
            return;
        }
        if (isAutreEtab && !form.autreEtablissement.trim()) {
            showSwal({ icon: "warning", text: "Veuillez saisir l'autre établissement", timer: 2000, showConfirmButton: false });
            return;
        }
        dispatch(createCandidatRequest(buildCandidatFormData(form, false)));
    };

    const submitEdit = () => {
        if (!selectedCandidat?.id) return;
        if (!form.nom.trim() || !form.prenom.trim()) {
            showSwal({ icon: "warning", text: "Nom et prénom obligatoires", timer: 2000, showConfirmButton: false });
            return;
        }
        if (isAutreEtab && !form.autreEtablissement.trim()) {
            showSwal({ icon: "warning", text: "Veuillez saisir l'autre établissement", timer: 2000, showConfirmButton: false });
            return;
        }
        dispatch(updateCandidatRequest(selectedCandidat.id, buildCandidatFormData(form)));
        closeEdit();
    };

    const confirmDelete = () => {
        if (!selectedCandidat?.id) return;
        dispatch(deleteCandidatRequest(selectedCandidat.id));
        closeDelete();
    };

    const getEtabLabelById = (id) => {
        if (!id) return "—";
        const o = etabOptions.find((x) => String(x.id) === String(id));
        return o?.label || `Établissement #${id}`;
    };

    const SourceSelect = () => (
        <div className="cvtField">
            <label>Source</label>
            <select
                value={form.source}
                onChange={(e) => setForm((p) => ({ ...p, source: e.target.value }))}
            >
                <option value="">Sélectionner une source</option>
                {SOURCE_OPTIONS.map((s) => (
                    <option key={s.value} value={s.value}>
                        {s.label}
                    </option>
                ))}
            </select>
        </div>
    );

    return (
        <div className="cvtPage">
            <div className="cvtHeader">
                <div>
                    <h1>CVthèque</h1>
                    <p>Gérez votre base de données de candidats</p>
                </div>
            </div>

            <div className="cvtWrap">
                <div className="cvtCard">
                    <div className="cvtBody">
                        <div className="cvtFilterSection">
                            <div className="cvtFilterTitle">
                                <Search size={16} />
                                Filtre de recherche
                            </div>

                            <div className="cvtFilterGrid">
                                <div className="cvtField">
                                    <label>Nom Complet</label>
                                    <input
                                        type="text"
                                        value={filters.fullname}
                                        onChange={(e) => handleFilterChange("fullname", e.target.value)}
                                        placeholder="Rechercher par nom..."
                                    />
                                </div>

                                <div className="cvtField">
                                    <label>Niveau d'étude</label>
                                    <select
                                        value={filters.niveauEtude}
                                        onChange={(e) => handleFilterChange("niveauEtude", e.target.value)}
                                    >
                                        <option value="">Tous</option>
                                        {NIVEAU_ETUDES_OPTIONS.map((o) => (
                                            <option key={o.value} value={o.value}>{o.label}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="cvtField">
                                    <label>Option/Spécialité</label>
                                    <select
                                        value={filters.optionSpecialite}
                                        onChange={(e) => handleFilterChange("optionSpecialite", e.target.value)}
                                    >
                                        <option value="">Toutes</option>
                                        {OPTION_SPECIALITE_OPTIONS.map((s) => (
                                            <option key={s.value} value={s.value}>{s.label}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="cvtField">
                                    <label>Type de candidature</label>
                                    <select
                                        value={filters.typeCandidature}
                                        onChange={(e) => handleFilterChange("typeCandidature", e.target.value)}
                                    >
                                        <option value="">Tous</option>
                                        {TYPE_CANDIDATURE_OPTIONS.map((t) => (
                                            <option key={t.value} value={t.value}>{t.label}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="cvtField">
                                    <label>Diplôme</label>
                                    <input
                                        type="text"
                                        value={filters.diplomeObtenu}
                                        onChange={(e) => handleFilterChange("diplomeObtenu", e.target.value)}
                                        placeholder="Rechercher par diplôme..."
                                    />
                                </div>

                                <div className="cvtField">
                                    <label>Établissement</label>
                                    <select
                                        value={filters.ecole}
                                        onChange={(e) => handleFilterChange("ecole", e.target.value)}
                                    >
                                        <option value="">Tous</option>
                                        {etabOptions.map((e) => (
                                            <option key={e.id} value={e.id}>{e.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="cvtFilterActions">
                                <button className="cvtBtn cvtBtn--primary" type="button" onClick={openCreate}>
                                    <Plus size={16} />
                                    Ajouter un candidat
                                </button>

                                <button className="cvtBtn cvtBtn--success" type="button" onClick={openParser}>
                                    <Sparkles size={16} />
                                    Parser IA
                                </button>

                                <button
                                    className={`cvtBtn ${isAnyFilterFilled ? "cvtBtn--warning" : "cvtBtn--ghost"}`}
                                    type="button"
                                    onClick={resetFilters}
                                    disabled={!isAnyFilterFilled}
                                >
                                    Réinitialiser les filtres
                                </button>
                            </div>

                            {(candLoading || etabLoading) && (
                                <div className="cvtMuted" style={{ marginTop: 10 }}>Chargement...</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="cvtWrap">
                <div className="cvtCard">
                    <div className="cvtBody">
                        {/*<div className="cvtTopRow">*/}
                        {/*    <h2 className="cvtTitle">CVthèque ({filteredCandidats.length})</h2>*/}
                        {/*</div>*/}

                        <div className="cvtTableWrap">
                            <table className="cvtTable">
                                <thead>
                                <tr>
                                    <th>Nom complet</th>
                                    <th>Email</th>
                                    <th>Type de candidature</th>
                                    <th>Niveau d'étude</th>
                                    <th>Établissement</th>
                                    <th className="is-right">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {filteredCandidats.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} className="cvtEmptyCell">Aucun candidat trouvé</td>
                                    </tr>
                                ) : (
                                    filteredCandidats.map((c) => (
                                        <tr key={c.id}>
                                            <td>
                                                <span className="cvtInline">
                                                    <User size={14} />
                                                    <span className="cvtStrong">{c.nom} {c.prenom}</span>
                                                </span>
                                            </td>
                                            <td className="cvtMuted">{c.email || "—"}</td>
                                            <td className="cvtMuted">{labelFromOptions(TYPE_CANDIDATURE_OPTIONS, c.typeCandidature, "—")}</td>
                                            <td className="cvtMuted">{labelFromOptions(NIVEAU_ETUDES_OPTIONS, c.niveauEtude, "—")}</td>
                                            <td className="cvtMuted">
                                                {c.etablissementId ? getEtabLabelById(c.etablissementId) : c.autreEtablissement || "—"}
                                            </td>
                                            <td className="is-right">
                                                <div className="cvtRowActions">
                                                    <button className="cvtIconBtn" type="button" title="Voir" onClick={() => openView(c)}>
                                                        <Eye size={16} />
                                                    </button>
                                                    <button className="cvtIconBtn" type="button" title="Modifier" onClick={() => openEdit(c)}>
                                                        <Edit2 size={16} />
                                                    </button>
                                                    <button
                                                        className="cvtIconBtn cvtIconBtn--danger"
                                                        type="button"
                                                        title="Supprimer"
                                                        onClick={() => openDelete(c)}
                                                    >
                                                        <Trash2 size={16} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>

                        {!!candState?.error && (
                            <div className="cvtWarning" style={{ marginTop: 10 }}>{String(candState.error)}</div>
                        )}
                    </div>
                </div>
            </div>

            <Modal
                open={showAddModal}
                title="Nouveau candidat"
                onClose={closeCreate}
                size="lg"
                footer={
                    <>
                        <button className="cvtBtn cvtBtn--ghost" type="button" onClick={closeCreate}>Annuler</button>
                        <button className="cvtBtn cvtBtn--primary" type="button" onClick={submitCreate}>Enregistrer</button>
                    </>
                }
            >
                <div className="cvtForm">
                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Nom *</label>
                            <input
                                type="text"
                                value={form.nom}
                                onChange={(e) => setForm((p) => ({ ...p, nom: e.target.value }))}
                                placeholder="Nom du candidat"
                            />
                        </div>
                        <div className="cvtField">
                            <label>Prénom *</label>
                            <input
                                type="text"
                                value={form.prenom}
                                onChange={(e) => setForm((p) => ({ ...p, prenom: e.target.value }))}
                                placeholder="Prénom du candidat"
                            />
                        </div>
                        <div className="cvtField">
                            <label>Genre</label>
                            <div className="cvtRadioGroup">
                                {GENRE_OPTIONS.map((g) => (
                                    <label key={g.value} className="cvtRadioItem">
                                        <input
                                            type="radio"
                                            name="genre"
                                            value={g.value}
                                            checked={String(form.genre) === String(g.value)}
                                            onChange={(e) => setForm((p) => ({ ...p, genre: e.target.value }))}
                                        />
                                        <span>{g.label}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Email *</label>
                            <input
                                type="email"
                                value={form.email}
                                onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
                                placeholder="email@exemple.com"
                            />
                        </div>
                        <div className="cvtField">
                            <label>Téléphone *</label>
                            <input
                                type="tel"
                                value={form.phone}
                                onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))}
                                placeholder="+212 6 XX XX XX XX"
                            />
                        </div>
                        <div className="cvtField">
                            <label>Adresse</label>
                            <input
                                type="text"
                                value={form.adresse}
                                onChange={(e) => setForm((p) => ({ ...p, adresse: e.target.value }))}
                                placeholder="Adresse complète"
                            />
                        </div>
                    </div>

                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Niveau d'étude</label>
                            <select
                                value={form.niveauEtude}
                                onChange={(e) => setForm((p) => ({ ...p, niveauEtude: e.target.value }))}
                            >
                                <option value="">Sélectionner un niveau</option>
                                {NIVEAU_ETUDES_OPTIONS.map((o) => (
                                    <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="cvtField">
                            <label>Diplôme obtenu</label>
                            <input
                                type="text"
                                value={form.diplomeObtenu}
                                onChange={(e) => setForm((p) => ({ ...p, diplomeObtenu: e.target.value }))}
                                placeholder="Ex: Master en Informatique"
                            />
                        </div>
                        <div className="cvtField">
                            <label>Années d'expérience</label>
                            <select
                                value={form.anneExperience}
                                onChange={(e) => setForm((p) => ({ ...p, anneExperience: e.target.value }))}
                            >
                                <option value="">Sélectionner</option>
                                {ANNEES_EXPERIENCE_OPTIONS.map((a) => (
                                    <option key={a} value={a}>{a}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Établissement</label>
                            <select
                                value={form.etablissementId}
                                onChange={(e) => setForm((p) => ({ ...p, etablissementId: e.target.value }))}
                            >
                                <option value="">Sélectionner un établissement</option>
                                {etabOptions.map((e) => (
                                    <option key={e.id} value={String(e.id)}>{e.label}</option>
                                ))}
                            </select>
                            {etabLoading && <div className="cvtMuted" style={{ marginTop: 6 }}>Chargement...</div>}
                        </div>

                        {isAutreEtab && (
                            <div className="cvtField">
                                <label>Autre établissement</label>
                                <input
                                    type="text"
                                    value={form.autreEtablissement}
                                    onChange={(e) => setForm((p) => ({ ...p, autreEtablissement: e.target.value }))}
                                    placeholder="Nom de l'établissement"
                                />
                            </div>
                        )}

                        <div className="cvtField">
                            <label>Option/Spécialité</label>
                            <select
                                value={form.optionSpecialite}
                                onChange={(e) => setForm((p) => ({ ...p, optionSpecialite: e.target.value }))}
                            >
                                <option value="">Sélectionner une spécialité</option>
                                {OPTION_SPECIALITE_OPTIONS.map((s) => (
                                    <option key={s.value} value={s.value}>{s.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Type de candidature</label>
                            <select
                                value={form.typeCandidature}
                                onChange={(e) => setForm((p) => ({ ...p, typeCandidature: e.target.value }))}
                            >
                                <option value="">Sélectionner un type</option>
                                {TYPE_CANDIDATURE_OPTIONS.map((t) => (
                                    <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                            </select>
                        </div>

                        <SourceSelect />

                        <div className="cvtField">
                            <label>CV *</label>
                            <div className="cvtFileUpload">
                                <input type="file" id="cv-upload" accept="*" onChange={(e) => handleFileChange("cv", e)} style={{ display: "none" }} />
                                <label htmlFor="cv-upload" className="cvtFileUploadBtn">
                                    <Upload size={16} />
                                    Choisir un fichier
                                </label>
                                {form.cvPreview && <div className="cvtFileName">{form.cvPreview}</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                open={showEditModal}
                title={`Modifier — ${selectedCandidat?.nom || ""} ${selectedCandidat?.prenom || ""}`}
                onClose={closeEdit}
                size="lg"
                footer={
                    <>
                        <button className="cvtBtn cvtBtn--ghost" type="button" onClick={closeEdit}>Annuler</button>
                        <button className="cvtBtn cvtBtn--primary" type="button" onClick={submitEdit}>Enregistrer</button>
                    </>
                }
            >
                <div className="cvtForm">
                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Nom *</label>
                            <input type="text" value={form.nom} onChange={(e) => setForm((p) => ({ ...p, nom: e.target.value }))} />
                        </div>
                        <div className="cvtField">
                            <label>Prénom *</label>
                            <input type="text" value={form.prenom} onChange={(e) => setForm((p) => ({ ...p, prenom: e.target.value }))} />
                        </div>
                    </div>

                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Email</label>
                            <input type="email" value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} />
                        </div>
                        <div className="cvtField">
                            <label>Téléphone</label>
                            <input type="tel" value={form.phone} onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))} />
                        </div>
                    </div>

                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Niveau d'étude</label>
                            <select value={form.niveauEtude} onChange={(e) => setForm((p) => ({ ...p, niveauEtude: e.target.value }))}>
                                <option value="">Sélectionner un niveau</option>
                                {NIVEAU_ETUDES_OPTIONS.map((o) => (
                                    <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="cvtField">
                            <label>Option/Spécialité</label>
                            <select value={form.optionSpecialite} onChange={(e) => setForm((p) => ({ ...p, optionSpecialite: e.target.value }))}>
                                <option value="">Sélectionner une spécialité</option>
                                {OPTION_SPECIALITE_OPTIONS.map((s) => (
                                    <option key={s.value} value={s.value}>{s.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>Type de candidature</label>
                            <select value={form.typeCandidature} onChange={(e) => setForm((p) => ({ ...p, typeCandidature: e.target.value }))}>
                                <option value="">Sélectionner un type</option>
                                {TYPE_CANDIDATURE_OPTIONS.map((t) => (
                                    <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                            </select>
                        </div>

                        <SourceSelect />
                    </div>

                    {selectedCandidat?.cv && (
                        <div className="cvtExistingFile">
                            <Download size={14} />
                            <a
                                href={buildCvUrl(selectedCandidat.cv)}
                                className="cvtLink"
                                target="_blank"
                                rel="noopener noreferrer"
                                download={selectedCandidat.cv}
                            >
                                {String(selectedCandidat.cv)}
                            </a>
                        </div>
                    )}

                    {selectedCandidat?.pieceIdentiteDocument && (
                        <div className="cvtExistingFile" style={{ marginTop: 8 }}>
                            <Download size={14} />
                            <a
                                href={buildPieceUrl(selectedCandidat.pieceIdentiteDocument)}
                                className="cvtLink"
                                target="_blank"
                                rel="noopener noreferrer"
                                download={selectedCandidat.pieceIdentiteDocument}
                            >
                                {String(selectedCandidat.pieceIdentiteDocument)}
                            </a>
                        </div>
                    )}

                    <div className="cvtFormRow">
                        <div className="cvtField">
                            <label>CV (remplacer)</label>
                            <div className="cvtFileUpload">
                                <input type="file" id="cv-upload-edit" accept="*" onChange={(e) => handleFileChange("cv", e)} style={{ display: "none" }} />
                                <label htmlFor="cv-upload-edit" className="cvtFileUploadBtn">
                                    <Upload size={16} />
                                    Choisir un fichier
                                </label>
                                {form.cvPreview && <div className="cvtFileName">{form.cvPreview}</div>}
                            </div>
                        </div>

                        {/*<div className="cvtField">*/}
                        {/*    <label>Pièce (remplacer)</label>*/}
                        {/*    <div className="cvtFileUpload">*/}
                        {/*        <input type="file" id="piece-upload-edit" accept="*" onChange={(e) => handleFileChange("piece", e)} style={{ display: "none" }} />*/}
                        {/*        <label htmlFor="piece-upload-edit" className="cvtFileUploadBtn">*/}
                        {/*            <Upload size={16} />*/}
                        {/*            Choisir un fichier*/}
                        {/*        </label>*/}
                        {/*        {form.piecePreview && <div className="cvtFileName">{form.piecePreview}</div>}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </Modal>

            <Modal
                open={showViewModal}
                title={`Détails — ${selectedCandidat?.nom || ""} ${selectedCandidat?.prenom || ""}`}
                onClose={closeView}
                footer={
                    <button className="cvtBtn cvtBtn--primary" type="button" onClick={closeView}>Fermer</button>
                }
            >
                {selectedCandidat && (
                    <div className="cvtViewContent">
                        <div className="cvtViewRow"><div className="cvtViewLabel">Nom complet:</div><div className="cvtViewValue">{selectedCandidat.nom} {selectedCandidat.prenom}</div></div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Genre:</div><div className="cvtViewValue">{labelFromOptions(GENRE_OPTIONS, selectedCandidat.genre, "—")}</div></div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Email:</div><div className="cvtViewValue">{selectedCandidat.email || "—"}</div></div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Téléphone:</div><div className="cvtViewValue">{selectedCandidat.phone || "—"}</div></div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Adresse:</div><div className="cvtViewValue">{selectedCandidat.adresse || "—"}</div></div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Niveau d'étude:</div><div className="cvtViewValue">{labelFromOptions(NIVEAU_ETUDES_OPTIONS, selectedCandidat.niveauEtude, "—")}</div></div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Diplôme obtenu:</div><div className="cvtViewValue">{selectedCandidat.diplomeObtenu || "—"}</div></div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Années d'expérience:</div><div className="cvtViewValue">{selectedCandidat.anneExperience || "—"}</div></div>
                        <div className="cvtViewRow">
                            <div className="cvtViewLabel">Établissement:</div>
                            <div className="cvtViewValue">
                                {selectedCandidat.etablissementId ? getEtabLabelById(selectedCandidat.etablissementId) : selectedCandidat.autreEtablissement || "—"}
                            </div>
                        </div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Spécialité:</div><div className="cvtViewValue">{labelFromOptions(OPTION_SPECIALITE_OPTIONS, selectedCandidat.optionSpecialite, "—")}</div></div>
                        <div className="cvtViewRow"><div className="cvtViewLabel">Type candidature:</div><div className="cvtViewValue">{labelFromOptions(TYPE_CANDIDATURE_OPTIONS, selectedCandidat.typeCandidature, "—")}</div></div>

                        <div className="cvtViewRow">
                            <div className="cvtViewLabel">Source:</div>
                            <div className="cvtViewValue">{labelFromOptions(SOURCE_OPTIONS, selectedCandidat.source, "—")}</div>
                        </div>

                        {selectedCandidat.cv && (
                            <div className="cvtViewRow">
                                <div className="cvtViewLabel">CV:</div>
                                <div className="cvtViewValue">
                                    <a
                                        href={buildCvUrl(selectedCandidat.cv)}
                                        className="cvtLink"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download={selectedCandidat.cv}
                                    >
                                        <Download size={14} />
                                        {String(selectedCandidat.cv)}
                                    </a>
                                </div>
                            </div>
                        )}

                        {selectedCandidat.pieceIdentiteDocument && (
                            <div className="cvtViewRow">
                                <div className="cvtViewLabel">Pièce jointe:</div>
                                <div className="cvtViewValue">
                                    <a
                                        href={buildPieceUrl(selectedCandidat.pieceIdentiteDocument)}
                                        className="cvtLink"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download={selectedCandidat.pieceIdentiteDocument}
                                    >
                                        <Download size={14} />
                                        {String(selectedCandidat.pieceIdentiteDocument)}
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </Modal>

            <Modal
                open={showDeleteModal}
                title="Confirmation de suppression"
                onClose={closeDelete}
                footer={
                    <>
                        <button className="cvtBtn cvtBtn--ghost" type="button" onClick={closeDelete}>Annuler</button>
                        <button className="cvtBtn cvtBtn--danger" type="button" onClick={confirmDelete}>Supprimer</button>
                    </>
                }
            >
                <div className="cvtDeleteContent">
                    <p>
                        Voulez-vous vraiment supprimer le candidat{" "}
                        <strong>{selectedCandidat?.nom} {selectedCandidat?.prenom}</strong> ?
                    </p>
                    <p className="cvtWarning">Cette action est irréversible.</p>
                </div>
            </Modal>

            <Modal
                open={showParserModal}
                title="Parser IA - Extraction de CV"
                onClose={closeParser}
                size="lg"
                footer={
                    <>
                        {parserStatus !== "idle" && (
                            <button className="cvtBtn cvtBtn--ghost" type="button" onClick={resetParser}>
                                Réinitialiser
                            </button>
                        )}
                        <button className="cvtBtn cvtBtn--primary" type="button" onClick={closeParser}>
                            Fermer
                        </button>
                    </>
                }
            >
                <div className="cvtParser">
                    {parserStatus !== "done" && (
                        <>
                            <div className="cvtParserIntro">
                                <strong>Parser IA</strong>
                                <span>Importez un CV pour lancer l'analyse.</span>
                            </div>

                            <div className="cvtField">
                                <label>Télécharger un CV</label>
                                <div className="cvtFileUpload">
                                    <input
                                        type="file"
                                        id="parser-upload"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        onChange={handleParserFileChange}
                                        style={{ display: "none" }}
                                    />
                                    <label htmlFor="parser-upload" className="cvtFileUploadBtn">
                                        <Upload size={16} />
                                        Choisir un fichier CV
                                    </label>
                                    {parserFileName && <div className="cvtFileName">{parserFileName}</div>}
                                </div>
                            </div>
                        </>
                    )}

                    {parserStatus === "analyzing" && (
                        <div className="cvtParserLoading" role="status" aria-live="polite">
                            <span className="cvtParserSpinner" />
                            <div>
                                <strong>Analyse en cours</strong>
                                <span>Extraction des informations du CV...</span>
                            </div>
                        </div>
                    )}

                    {parserStatus === "done" && (
                        <div className="cvtParsedResult">
                            <div className="cvtParsedTab">{STATIC_PARSED_CV.title}</div>

                            <div className="cvtParsedForm">
                                <div className="cvtField">
                                    <label>Nom</label>
                                    <input type="text" value={STATIC_PARSED_CV.nom} readOnly />
                                </div>

                                <div className="cvtField">
                                    <label>Prénom</label>
                                    <input type="text" value={STATIC_PARSED_CV.prenom} readOnly />
                                </div>

                                <div className="cvtField">
                                    <label>Email</label>
                                    <input type="email" value={STATIC_PARSED_CV.email} readOnly />
                                </div>

                                <div className="cvtField">
                                    <label>Téléphone</label>
                                    <input type="text" value={STATIC_PARSED_CV.telephone} readOnly />
                                </div>

                                <div className="cvtField">
                                    <label>Sexe</label>
                                    <select value={STATIC_PARSED_CV.sexe} disabled>
                                        <option>Femme</option>
                                    </select>
                                </div>

                                <div className="cvtField">
                                    <label>Niveau d'étude</label>
                                    <select value={STATIC_PARSED_CV.niveauEtude} disabled>
                                        <option>Master (Bac + 5)</option>
                                    </select>
                                </div>

                                <div className="cvtField">
                                    <label>Spécialité/Option</label>
                                    <input type="text" value={STATIC_PARSED_CV.specialite} readOnly />
                                </div>

                                <div className="cvtField">
                                    <label>Années d'expérience</label>
                                    <input type="text" value={STATIC_PARSED_CV.anneesExperience} readOnly />
                                </div>

                                <div className="cvtField cvtParsedFull">
                                    <label>Diplôme obtenu</label>
                                    <input type="text" value={STATIC_PARSED_CV.diplome} readOnly />
                                </div>

                                <div className="cvtField cvtParsedFull">
                                    <label>Établissement</label>
                                    <input type="text" value={STATIC_PARSED_CV.etablissement} readOnly />
                                </div>
                            </div>

                            <div className="cvtParsedFile">
                                <FileText size={17} />
                                <span>CV associé:</span>
                                <strong>{parserFileName || STATIC_PARSED_CV.cvAssocie}</strong>
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        </div>
    );
}
